import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/storefront/Navbar';
import Footer from '../components/storefront/Footer';
import supabase from '../supabase/supabase';
import { FiArrowLeft } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const SitePage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPage();
  }, [slug]);

  const fetchPage = async () => {
    const { data } = await supabase
      .from('site_pages')
      .select('*')
      .eq('slug', slug)
      .maybeSingle();
    if (data) setPage(data);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="bg-brand-sand min-h-screen font-sans flex flex-col pt-28 md:pt-36 lg:pt-24">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <p className="text-brand-lightText font-serif italic">Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!page) {
    return (
      <div className="bg-brand-sand min-h-screen font-sans flex flex-col pt-28 md:pt-36 lg:pt-24">
        <Navbar />
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="text-center">
            <h1 className="text-4xl font-serif text-brand-darkSage mb-4">Page Not Found</h1>
            <Link to="/" className="bg-brand-darkSage text-white px-8 py-3 rounded-full text-xs font-bold uppercase tracking-widest hover:bg-brand-gold transition-all">
              Return Home
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-brand-sand min-h-screen font-sans flex flex-col pt-28 md:pt-36 lg:pt-24">
      <Navbar />
      <div className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-8 md:py-12 w-full">

        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-brand-lightText hover:text-brand-gold transition-colors mb-6 md:mb-8">
          <SafeIcon icon={FiArrowLeft} size={14} /> Back to Home
        </Link>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-brand-darkSage mb-8 md:mb-10">{page.title}</h1>

        <div
          className="prose prose-lg max-w-none blog-content"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-brand-darkSage/10 text-xs text-brand-lightText">
          Last updated: {new Date(page.updated_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SitePage;